import { render, staticRenderFns } from "./SimpleBar.vue?vue&type=template&id=000a6512"
import script from "./SimpleBar.vue?vue&type=script&lang=js"
export * from "./SimpleBar.vue?vue&type=script&lang=js"
import style0 from "./SimpleBar.vue?vue&type=style&index=0&id=000a6512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports